<template>
    <div class="text-center">
        <img src="../assets/images/empty-box.svg" style="margin-bottom:20px; height:150px; opacity:0.2;">
        <h5 class="text-muted">{{ $t('message.no_result') }}</h5>
    </div>
</template>

<script>
    export default {
        name: "NoResult.vue"
    }
</script>

<style scoped>

</style>